import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
// import axios from "axios";
import axios from "../context/axios";
import "react-quill/dist/quill.snow.css";
import { toast, Toaster } from "react-hot-toast";

const MailTemplates = () => {
  const [activeTab, setActiveTab] = useState("user");
  // const [templates, setTemplates] = useState({ user: "", admin: "" });
  const [templates, setTemplates] = useState({
    user: "",
    admin: "",
    agency: "",
  });

  const [showSource, setShowSource] = useState(false);
  const [sourceContent, setSourceContent] = useState("");

  useEffect(() => {
    // axios.get("/templates/templates").then((res) => {
    //   setTemplates(res.data.templates || { user: "", admin: "" });
    // });
    axios.get("/templates/templates").then((res) => {
      setTemplates(res.data.templates || { user: "", admin: "", agency: "" });
    });
  }, []);

  const handleSave = () => {
    axios.post("/templates/templates", templates).then(() => {
      window.scroll(0,0)
      toast.success("Templates saved successfully!");
    });
  };

  const handleSourceOpen = () => {
    setSourceContent(templates[activeTab]);
    setShowSource(true);
  };

  const handleSourceSave = () => {
    setTemplates((prev) => ({ ...prev, [activeTab]: sourceContent }));
    setShowSource(false);
  };

  return (
    <div className="min-h-screen py-2 px-2 ">
      <div className="max-w-5xl mx-auto  p-6 rounded-lg ">
        <h2 className="text-4xl font-extrabold  text-indigo-600 mb-8">
          Mail Templates
        </h2>

        <div className="flex space-x-4 mb-6">
          {/* {["user", "admin"].map((type) => (
            <button
              key={type}
              className={`px-6 py-3 border rounded-lg font-semibold transition ${
                activeTab === type
                  ? "bg-indigo-600 text-white border-indigo-400"
                  : "bg-white hover:bg-indigo-50 text-gray-700 border-gray-300"
              }`}
              onClick={() => setActiveTab(type)}
            >
              {type === "user" ? "User Template" : "Admin Template"}
            </button>
          ))} */}
          {["user", "admin"].map((type) => (
            <button
              key={type}
              className={`px-6 py-3 border rounded-lg font-semibold transition ${
                activeTab === type
                  ? "bg-indigo-600 text-white border-indigo-400"
                  : "bg-white hover:bg-indigo-50 text-gray-700 border-gray-300"
              }`}
              onClick={() => setActiveTab(type)}
            >
              {/* {type === "user"
                ? "User Template"
                : type === "admin"
                ? "Admin Template"
                : "Agency Verification Template"} */}
                {type === "user"
  ? "User Template"
  : type === "admin"
  ? "Admin Template"
  : null}

            </button>
          ))}
        </div>

        <div className="flex justify-between mb-4">
          <button
            onClick={handleSourceOpen}
            className="text-sm text-indigo-600 underline hover:text-indigo-800"
          >
            View/Edit HTML Source
          </button>
        </div>

        <ReactQuill
          value={templates[activeTab]}
          onChange={(value) =>
            setTemplates((prev) => ({ ...prev, [activeTab]: value }))
          }
          theme="snow"
        />

        <button
          onClick={handleSave}
          className="mt-6 bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded shadow"
        >
          Save Templates
        </button>
      </div>

      {/* Source Modal */}
      {showSource && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg p-6">
            <h3 className="text-xl font-semibold text-indigo-600 mb-4">
              Edit HTML Source
            </h3>
            <textarea
              rows={15}
              value={sourceContent}
              onChange={(e) => setSourceContent(e.target.value)}
              className="w-full border border-gray-300 rounded p-3 font-mono text-sm"
            />
            <div className="flex justify-end space-x-4 mt-4">
              <button
                onClick={() => setShowSource(false)}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={handleSourceSave}
                className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
       <Toaster position="top-right" />
    </div>
  );
};

export default MailTemplates;

